module.exports = __webpack_public_path__ + "static/media/vigilancia.cc344af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contenido/vigilancia.png
// module id = 377
// module chunks = 0